import { render, staticRenderFns } from "./AprovarNotasFiscaisDeServico.vue?vue&type=template&id=871b6534&scoped=true"
import script from "./AprovarNotasFiscaisDeServico.vue?vue&type=script&lang=js"
export * from "./AprovarNotasFiscaisDeServico.vue?vue&type=script&lang=js"
import style0 from "./AprovarNotasFiscaisDeServico.vue?vue&type=style&index=0&id=871b6534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871b6534",
  null
  
)

export default component.exports